import React from 'react';

import {
  useStatusBar,
  useStatusBarWithPipeDeletion,
  useStatusBarWithSystemDeletion,
} from '../hooks/useStatusBar';

import { StatusBar } from '../components/status-bar/StatusBar.view';

export const StatusBarContainer: React.FC<{
  collapsed: boolean;
}> = (props) => {
  const { collapsed = false } = props;

  const tasks = useStatusBar();
  const withPipes = useStatusBarWithPipeDeletion(tasks);
  const withSystems = useStatusBarWithSystemDeletion(withPipes);

  const isAnyTaskRunning = withSystems.some((t) => t.value);

  return (
    <StatusBar isAnyTaskRunning={isAnyTaskRunning} tasks={withSystems} collapsed={collapsed} />
  );
};
